module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/999b009161f90685de12f1c0caa5c44a.png";